<template>
  <rest-page
    :fetch-endpoint="fetchEndpoint"
    ref="featuredPage"
    class="categorised-page"
  >
    <el-row type="flex" class="row-wrap">
      <el-col v-for="block in model" :key="block.category_id" :span="12">
        <form-section
          :title="getCategorySectionTitle(block)"
          v-loading="loading"
          class="category-container"
        >
          <template slot="controls">
            <el-button
              v-if="canManageCategorisedTagFeatured"
              @click="setCategory(block.category_id)"
              icon="el-icon-setting"
              type="primary"
              plain
            >
              {{ $t('Profiles_Button_EditFeaturedData') }}
            </el-button>
          </template>

          <div>
            <div class="block-container">
              <el-row>
                <el-col
                  v-for="(groupAttributes, groupName) in block.attributes"
                  :key="groupName"
                  :span="24"
                >
                  <el-menu class="categorised-settings-nav">
                    <el-menu-item
                      class="main-items"
                      :key="groupName"
                      :index="groupName.toString()"
                    >
                      <template slot="title">
                        <div class="item-title-container">
                          <b>{{ groupName }}</b>
                        </div>
                      </template>
                    </el-menu-item>
                    <el-menu-item
                      v-for="(item, index) in groupAttributes"
                      :key="index"
                      :index="index.toString()"
                      class="main-items"
                    >
                      <template slot="title">
                        <div class="item-title-container">
                          <span>{{ getItemName(item) }}</span>
                          <div class="categorised-status-container">
                            <template v-if="isEditing(item.title)">
                              <el-input
                                v-if="
                                  item.type !== TagType.BOOLEAN &&
                                    item.type !== TagType.ARRAY &&
                                    item.type !== TagType.OBJECT
                                "
                                v-model="editingValues[item.title]"
                                class="attribute-input"
                                size="small"
                              />
                              <el-input
                                v-else-if="
                                  item.type === TagType.ARRAY ||
                                    item.type === TagType.OBJECT
                                "
                                v-model="editingValues[item.title]"
                                type="textarea"
                                :rows="4"
                                class="attribute-textarea"
                                size="small"
                              />
                              <el-dropdown
                                v-else-if="canUpdateCategorisedAttributes"
                                @command="handleDropdownCommand(item, $event)"
                              >
                                <span class="clickable">
                                  {{ formatValue(item) }}
                                  <i
                                    class="el-icon-arrow-down el-icon--right"
                                  />
                                </span>
                                <el-dropdown-menu
                                  slot="dropdown"
                                  trigger="click"
                                >
                                  <el-dropdown-item
                                    v-if="editingValues[item.title] !== 1"
                                    command="yes"
                                  >
                                    {{ $t('Rest_Form_Yes') }}
                                  </el-dropdown-item>
                                  <el-dropdown-item
                                    v-if="editingValues[item.title] !== 0"
                                    command="no"
                                  >
                                    {{ $t('Rest_Form_No') }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                              <div class="attribute-actions">
                                <i
                                  class="el-icon-check save-icon"
                                  @click="saveAttribute(item)"
                                  title="Save"
                                ></i>
                                <i
                                  class="el-icon-close cancel-icon"
                                  @click="cancelEdit(item.title)"
                                  title="Cancel"
                                ></i>
                              </div>
                            </template>
                            <template v-else>
                              <el-dropdown
                                v-if="
                                  attributes &&
                                    item &&
                                    canUpdateCategorisedAttributes &&
                                    item.type === TagType.BOOLEAN
                                "
                                @command="handleDropdownCommand(item, $event)"
                                trigger="click"
                              >
                                <span class="selected-boolean">
                                  <i
                                    class="status-icon"
                                    :class="getBooleanIcon(item.value)"
                                  ></i>
                                  {{ formatValue(item) }}
                                  <i
                                    class="el-icon-more attribute-menu-icon"
                                  ></i>
                                </span>

                                <el-dropdown-menu
                                  slot="dropdown"
                                  trigger="click"
                                  class="boolean-dropdown-menu"
                                >
                                  <el-dropdown-item
                                    v-if="item.value !== 1"
                                    command="yes"
                                  >
                                    <i class="status-icon el-icon-success"></i>
                                    {{ $t('Rest_Form_Yes') }}
                                  </el-dropdown-item>

                                  <el-dropdown-item
                                    v-if="item.value !== 0"
                                    command="no"
                                  >
                                    <i class="status-icon el-icon-error"></i>
                                    {{ $t('Rest_Form_No') }}
                                  </el-dropdown-item>

                                  <el-dropdown-item
                                    v-if="
                                      hasAuditLogFeature && item.value !== null
                                    "
                                    command="OpenAuditLog"
                                  >
                                    {{
                                      $t('Profiles_Channels_Action_Audit_Log')
                                    }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>

                              <el-dropdown
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canReadCategorisedAttributes &&
                                    !canUpdateCategorisedAttributes &&
                                    hasAuditLogFeature &&
                                    item.type === TagType.BOOLEAN &&
                                    item.value !== null
                                "
                                @command="handleDropdownCommand(item, $event)"
                                trigger="click"
                              >
                                <span class="selected-boolean">
                                  <i
                                    class="status-icon"
                                    :class="getBooleanIcon(item.value)"
                                  ></i>
                                  {{ formatValue(item) }}
                                  <i
                                    class="el-icon-more attribute-menu-icon"
                                  ></i>
                                </span>

                                <el-dropdown-menu
                                  slot="dropdown"
                                  trigger="click"
                                  class="boolean-dropdown-menu"
                                >
                                  <el-dropdown-item command="OpenAuditLog">
                                    {{
                                      $t('Profiles_Channels_Action_Audit_Log')
                                    }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>

                              <overflow-tooltip
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canReadCategorisedAttributes &&
                                    item.type === TagType.BOOLEAN
                                "
                                :value="formatValue(item)"
                              />

                              <div
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canUpdateCategorisedAttributes &&
                                    item.type !== TagType.BOOLEAN &&
                                    !shouldValueBeClickable(item)
                                "
                                class="attribute-value-container"
                              >
                                <div
                                  v-if="
                                    item.type === TagType.ARRAY ||
                                      item.type === TagType.OBJECT
                                  "
                                  class="truncated-json-wrapper"
                                >
                                  <span class="truncated-display">{{
                                    formatValue(item)
                                  }}</span>
                                  <overflow-tooltip
                                    :value="getTooltipValue(item)"
                                    class="json-preview-tooltip"
                                  />
                                </div>
                                <overflow-tooltip
                                  v-else
                                  :value="getTooltipValue(item)"
                                />
                                <el-dropdown
                                  @command="handleDropdownCommand(item, $event)"
                                  trigger="click"
                                >
                                  <i
                                    class="el-icon-more attribute-menu-icon"
                                  ></i>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit">
                                      {{ $t('RestList_Action_Update') }}
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                      v-if="
                                        hasAuditLogFeature &&
                                          item.value !== null
                                      "
                                      command="viewLog"
                                    >
                                      {{
                                        $t('Profiles_Channels_Action_Audit_Log')
                                      }}
                                    </el-dropdown-item>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>

                              <el-dropdown
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canUpdateCategorisedAttributes &&
                                    item.type !== TagType.BOOLEAN &&
                                    shouldValueBeClickable(item)
                                "
                                @command="handleDropdownCommand(item, $event)"
                                trigger="click"
                              >
                                <span class="clickable attribute-value">
                                  <div
                                    v-if="
                                      item.type === TagType.ARRAY ||
                                        item.type === TagType.OBJECT
                                    "
                                    class="truncated-json-wrapper"
                                  >
                                    <span class="truncated-display">{{
                                      formatValue(item)
                                    }}</span>
                                    <overflow-tooltip
                                      :value="getTooltipValue(item)"
                                      class="json-preview-tooltip"
                                    />
                                  </div>
                                  <overflow-tooltip
                                    v-else
                                    :value="getTooltipValue(item)"
                                  />
                                  <i
                                    class="el-icon-more attribute-menu-icon"
                                  ></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item command="edit">
                                    {{ $t('RestList_Action_Update') }}
                                  </el-dropdown-item>
                                  <el-dropdown-item
                                    v-if="
                                      hasAuditLogFeature && item.value !== null
                                    "
                                    command="viewLog"
                                  >
                                    {{
                                      $t('Profiles_Channels_Action_Audit_Log')
                                    }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>

                              <div
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canReadCategorisedAttributes &&
                                    !canUpdateCategorisedAttributes &&
                                    hasAuditLogFeature &&
                                    item.type !== TagType.BOOLEAN &&
                                    item.value !== null &&
                                    !shouldValueBeClickable(item)
                                "
                                class="attribute-value-container"
                              >
                                <div
                                  v-if="
                                    item.type === TagType.ARRAY ||
                                      item.type === TagType.OBJECT
                                  "
                                  class="truncated-json-wrapper"
                                >
                                  <span class="truncated-display">{{
                                    formatValue(item)
                                  }}</span>
                                  <overflow-tooltip
                                    :value="getTooltipValue(item)"
                                    class="json-preview-tooltip"
                                  />
                                </div>
                                <overflow-tooltip
                                  v-else
                                  :value="getTooltipValue(item)"
                                />
                                <el-dropdown
                                  @command="handleDropdownCommand(item, $event)"
                                  trigger="click"
                                >
                                  <i
                                    class="el-icon-more attribute-menu-icon"
                                  ></i>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="viewLog">
                                      {{
                                        $t('Profiles_Channels_Action_Audit_Log')
                                      }}
                                    </el-dropdown-item>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>

                              <el-dropdown
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canReadCategorisedAttributes &&
                                    !canUpdateCategorisedAttributes &&
                                    hasAuditLogFeature &&
                                    item.type !== TagType.BOOLEAN &&
                                    item.value !== null &&
                                    shouldValueBeClickable(item)
                                "
                                @command="handleDropdownCommand(item, $event)"
                                trigger="click"
                              >
                                <span class="clickable attribute-value">
                                  <div
                                    v-if="
                                      item.type === TagType.ARRAY ||
                                        item.type === TagType.OBJECT
                                    "
                                    class="truncated-json-wrapper"
                                  >
                                    <span class="truncated-display">{{
                                      formatValue(item)
                                    }}</span>
                                    <overflow-tooltip
                                      :value="getTooltipValue(item)"
                                      class="json-preview-tooltip"
                                    />
                                  </div>
                                  <overflow-tooltip
                                    v-else
                                    :value="getTooltipValue(item)"
                                  />
                                  <i
                                    class="el-icon-more attribute-menu-icon"
                                  ></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item command="viewLog">
                                    {{
                                      $t('Profiles_Channels_Action_Audit_Log')
                                    }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>

                              <div
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canReadCategorisedAttributes &&
                                    item.type !== TagType.BOOLEAN &&
                                    !shouldValueBeClickable(item)
                                "
                                class="attribute-value-container"
                              >
                                <div
                                  v-if="
                                    item.type === TagType.ARRAY ||
                                      item.type === TagType.OBJECT
                                  "
                                  class="truncated-json-wrapper"
                                >
                                  <span class="truncated-display">{{
                                    formatValue(item)
                                  }}</span>
                                  <overflow-tooltip
                                    :value="getTooltipValue(item)"
                                    class="json-preview-tooltip"
                                  />
                                </div>
                                <overflow-tooltip
                                  v-else
                                  :value="getTooltipValue(item)"
                                />
                              </div>

                              <div
                                v-else-if="
                                  attributes &&
                                    item &&
                                    canReadCategorisedAttributes &&
                                    item.type !== TagType.BOOLEAN &&
                                    shouldValueBeClickable(item)
                                "
                                class="truncated-json-wrapper"
                              >
                                <span
                                  v-if="
                                    item.type === TagType.ARRAY ||
                                      item.type === TagType.OBJECT
                                  "
                                  class="truncated-display"
                                >
                                  {{ formatValue(item) }}
                                </span>
                                <overflow-tooltip
                                  v-if="
                                    item.type === TagType.ARRAY ||
                                      item.type === TagType.OBJECT
                                  "
                                  :value="getTooltipValue(item)"
                                  class="json-preview-tooltip"
                                />
                                <overflow-tooltip
                                  v-else
                                  :value="getTooltipValue(item)"
                                />
                              </div>

                              <span v-else style="line-height: 28px">
                                *********
                              </span>
                            </template>
                          </div>
                        </div>
                      </template>
                    </el-menu-item>
                  </el-menu>
                </el-col>
              </el-row>
            </div>
          </div>
        </form-section>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-pagination
        v-if="pagesCount > 1"
        background
        class="paginator"
        :layout="'prev, pager, next'"
        :page-count="pagesCount"
        :current-page="currentPage"
        :disabled="false"
        @current-change="reloadPage"
      >
        <template>
          <ul class="el-pager">
            <li class="number active">{{ currentPage }}</li>
          </ul>
        </template>
      </el-pagination>
    </el-row>
    <featured-attributes-dialog
      v-if="dialogVisible"
      :profile-id="profileId"
      :category-id="selectedCategory"
      :visible.sync="dialogVisible"
      @updated="updateModel"
    />
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import FormSection from '@/common/components/form/FormSection'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'
import { projectEndpoint } from '@/core/helpers'
import FeaturedAttributesDialog from '@/modules/profiles/components/categorised-attributes/FeaturedAttributesDialog'
import { TagType } from '@/modules/data-manager/enum/TagTypeEnum'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'FeaturedAttributes',

  components: {
    FeaturedAttributesDialog,
    RestPage,
    FormSection,
    OverflowTooltip
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      model: {},
      attributes: [],
      aggregates: [],
      loading: false,
      selectedCategory: null,
      pagesCount: 0,
      currentPage: 1,
      TagType,
      editingValues: {},
      originalValues: {},
      editingAttributes: {}
    }
  },

  computed: {
    fetchEndpoint() {
      return [this.fetchFeaturedAttributesEndpoint]
    },

    fetchFeaturedAttributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `categorised-attributes/attributes?profile_id=${this.profileId}&page=${this.currentPage}`,
        handler: data => {
          this.model = data.data
          this.pagesCount = data.totalPages
        }
      })
    },

    canManageCategorisedTagFeatured() {
      return this.$can('CategorisedTagFeatured::Manage')
    },

    canUpdateCategorisedAttributes() {
      return this.$can('CategorisedAttributeValue::Update')
    },

    canReadCategorisedAttributes() {
      return this.$can('CategorisedAttributeValue::Read')
    },

    hasAuditLogFeature() {
      return (
        this.$hasFeature('auditLogProfile') && this.$can('AuditLog:ReadAccess')
      )
    },

    dialogVisible: {
      get() {
        return !!this.selectedCategory
      },
      set(value) {
        if (!value) {
          this.selectedCategory = null
        }
      }
    }
  },

  methods: {
    formatValue(item) {
      let value = item.value
      if (value === null || value === '') {
        return '-'
      } else if (item.type === TagType.BOOLEAN) {
        return value ? this.$t('Rest_Form_Yes') : this.$t('Rest_Form_No')
      } else if (item.type === TagType.ARRAY || item.type === TagType.OBJECT) {
        return this.formatLongValue(value)
      } else {
        return value
      }
    },

    formatLongValue(value) {
      const maxLength = 50
      let stringValue = ''

      if (typeof value === 'string') {
        stringValue = value
      } else {
        try {
          stringValue = JSON.stringify(value)
        } catch (e) {
          stringValue = String(value)
        }
      }

      if (stringValue.length > maxLength) {
        return stringValue.substring(0, maxLength) + '...'
      }

      return stringValue
    },

    getTooltipValue(item) {
      if (item.type === TagType.ARRAY || item.type === TagType.OBJECT) {
        return item.value
      }
      return this.formatValue(item)
    },

    getItemName(item) {
      if (item.display_name) {
        return item.display_name
      }

      return item.title
    },

    shouldValueBeClickable(item) {
      if (item.type === TagType.ARRAY || item.type === TagType.OBJECT) {
        const value = item.value
        if (
          value !== null &&
          value !== undefined &&
          value !== '' &&
          this.formatValue(item) !== '-'
        ) {
          return false
        }
      }
      return true
    },

    saveAttribute(item) {
      let value = this.editingValues[item.title]
      if (value !== undefined) {
        if (item.type === TagType.ARRAY || item.type === TagType.OBJECT) {
          if (value === '' || value === null) {
            value = null
          } else {
            try {
              value = JSON.parse(value)
            } catch (e) {}
          }
        }
      } else {
        value = item.value
      }

      const data = {
        name: item.title,
        value: value
      }

      this.saveAttributeValue(data, () => {
        this.cancelEdit(item.title)
        this.reloadPage()
      })
    },

    saveAttributeEndpoint(data) {
      return projectEndpoint({
        method: 'patch',
        url: `profiles/${this.$route.query.profile_id}/attributes/${data.name}`
      })
    },

    saveAttributeValue(data, onSuccess = null) {
      this.loading = true
      RestApi({ ...this.saveAttributeEndpoint(data), ...{ data } })
        .then(response => {
          const attributeName = response.name || data.name
          this.updateAttributeValue(attributeName, response.data || response)
          this.$message({
            message: this.$t(
              'Profiles_Message_FeaturedAttributesUpdatedSuccessMessage'
            ),
            type: 'success'
          })
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess()
          }
        })
        .catch(error => {
          this.$message({
            message: error.message || this.$t('Profiles_Message_Error'),
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    updateModel() {
      this.setCategory()
      this.reloadPage()
    },

    reloadPage(val = null) {
      if (val) {
        this.currentPage = val
      }
      setTimeout(() => {
        this.$refs['featuredPage'].reload()
      }, 1000)
    },

    setCategory(category = null) {
      this.selectedCategory = category
    },

    handleDropdownCommand(item, command) {
      if (command === 'OpenAuditLog' || command === 'viewLog') {
        this.openAuditLog(item)
        return
      }

      if (command === 'edit') {
        this.startEdit(item)
        return
      }

      if (command === 'yes' || command === 'no') {
        if (
          item.type === TagType.BOOLEAN &&
          !this.canUpdateCategorisedAttributes
        ) {
          return
        }
        if (this.isEditing(item.title)) {
          if (command === 'yes') {
            this.$set(this.editingValues, item.title, 1)
          } else {
            this.$set(this.editingValues, item.title, 0)
          }
        } else {
          let data = {
            name: item.title
          }
          if (command === 'yes') {
            data['value'] = 1
          } else {
            data['value'] = 0
          }
          this.saveAttributeValue(data)
        }
      }
    },

    openAuditLog(item) {
      let filter = '{"field":"' + item.title + '"}'

      this.$router.push({
        name: 'ProfileAuditLog',
        query: {
          project_id: this.$route.query.project_id,
          profile_num: this.$route.query.profile_num,
          profile_id: this.profileId,
          filters: filter
        }
      })
    },

    getCategorySectionTitle(item) {
      let name = item.group_title || item.group_name
      return name + ' ' + this.$t('Profiles_Title_Attributes')
    },

    isEditing(attributeName) {
      return !!this.editingAttributes[attributeName]
    },

    startEdit(item) {
      const currentValue = item.value
      let stringValue = ''

      if (currentValue === null || currentValue === undefined) {
        stringValue = ''
      } else if (item.type === TagType.ARRAY || item.type === TagType.OBJECT) {
        try {
          stringValue = JSON.stringify(currentValue, null, 2)
        } catch (e) {
          stringValue = String(currentValue)
        }
      } else {
        stringValue = String(currentValue)
      }

      this.$set(this.editingValues, item.title, stringValue)
      this.$set(this.originalValues, item.title, stringValue)
      this.$set(this.editingAttributes, item.title, true)
    },

    cancelEdit(attributeName) {
      this.$delete(this.editingValues, attributeName)
      this.$delete(this.originalValues, attributeName)
      this.$delete(this.editingAttributes, attributeName)
    },

    updateAttributeValue(attributeName, updatedAttribute) {
      if (!updatedAttribute || typeof updatedAttribute !== 'object') {
        return
      }

      const searchName = updatedAttribute.name || attributeName
      const categoryId = updatedAttribute.category_id

      const refreshBlock = (blockKey, blockValue, isArrayModel) => {
        const clonedBlock = {
          ...blockValue,
          attributes: { ...blockValue.attributes }
        }

        if (isArrayModel) {
          this.$set(this.model, blockKey, clonedBlock)
        } else {
          this.$set(this.model, String(blockKey), clonedBlock)
        }
      }

      const tryUpdateBlock = (block, blockKey, isArrayModel) => {
        if (
          !block ||
          !block.attributes ||
          typeof block.attributes !== 'object'
        ) {
          return false
        }

        const groupNames = Object.keys(block.attributes)
        for (let j = 0; j < groupNames.length; j++) {
          const groupName = groupNames[j]
          const groupAttributes = block.attributes[groupName]

          if (!Array.isArray(groupAttributes)) {
            continue
          }

          const attributeIndex = groupAttributes.findIndex(attr => {
            if (!attr) return false
            return attr.title === searchName || attr.title === attributeName
          })

          if (attributeIndex !== -1) {
            const attribute = groupAttributes[attributeIndex]
            const newValue =
              updatedAttribute.value !== undefined
                ? updatedAttribute.value
                : null

            this.$set(attribute, 'value', newValue)

            if (updatedAttribute.type !== undefined) {
              this.$set(attribute, 'type', updatedAttribute.type)
            }
            if (updatedAttribute.timestamp !== undefined) {
              this.$set(attribute, 'timestamp', updatedAttribute.timestamp)
            }

            this.$set(block.attributes, groupName, [...groupAttributes])

            refreshBlock(blockKey, block, isArrayModel)

            return true
          }
        }

        return false
      }

      const tryUpdateByCategory = () => {
        if (!categoryId) {
          return false
        }

        if (Array.isArray(this.model)) {
          const blockIndex = this.model.findIndex(
            block => block && String(block.category_id) === String(categoryId)
          )
          if (blockIndex !== -1) {
            return tryUpdateBlock(this.model[blockIndex], blockIndex, true)
          }
          return false
        }

        const block = this.model[String(categoryId)]
        if (block) {
          return tryUpdateBlock(block, String(categoryId), false)
        }
        return false
      }

      if (tryUpdateByCategory()) {
        return
      }

      if (Array.isArray(this.model)) {
        for (let i = 0; i < this.model.length; i++) {
          if (tryUpdateBlock(this.model[i], i, true)) {
            return
          }
        }
      } else if (this.model && typeof this.model === 'object') {
        const modelKeys = Object.keys(this.model)
        for (let i = 0; i < modelKeys.length; i++) {
          const key = modelKeys[i]
          if (tryUpdateBlock(this.model[key], key, false)) {
            return
          }
        }
      }
    },

    getBooleanIcon(val) {
      if (parseInt(val) === 1) {
        return 'el-icon-success'
      }

      if (parseInt(val) === 0) {
        return 'el-icon-error'
      }

      return 'el-icon-remove'
    }
  }
}
</script>

<style scoped lang="scss">
.block-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #7e8596;
  margin-bottom: 17px;
}

.row-wrap {
  flex-wrap: wrap;
}

.boolean-dropdown-menu /deep/ .el-dropdown-menu__item {
  display: flex;
  align-items: center;
}

.status-icon {
  width: 18px;
  height: 18px;
  border-radius: 9px;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.el-icon-success {
    color: #1fca10;
  }

  &.el-icon-error {
    color: #f56c6c;
  }
}

.categorised-page {
  overflow-x: hidden !important;
}

.categorised-settings-nav {
  border: 1px solid #dbdee7;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;

  .main-items:not(:last-child) {
    box-shadow: inset 0 -1px 0 #f2f2f2;
  }

  .main-items {
    overflow: visible;
  }

  .item-title-container {
    display: flex;
    justify-content: space-between;
  }

  .attribute-value-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .attribute-menu-icon {
    cursor: pointer;
    transform: rotate(90deg);
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 1;
  }

  .categorised-status-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .categorised-status-container .attribute-textarea {
    align-self: flex-start;
  }

  .categorised-status-container .selected-boolean {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .categorised-status-container .selected-boolean .attribute-menu-icon {
    margin-left: 4px;
  }
}

.attribute-value {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.attribute-value .attribute-menu-icon {
  flex-shrink: 0;
}

.truncated-json-wrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  max-width: 300px;
}

.truncated-display {
  display: inline-block;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  position: relative;
  z-index: 1;
}

.json-preview-tooltip {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.json-preview-tooltip /deep/ .label {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.01;
  cursor: pointer;
  color: transparent;
  font-size: 1px;
  overflow: hidden;
}

.attribute-value-container /deep/ .overflow-tooltip .label,
.attribute-value /deep/ .overflow-tooltip .label {
  max-width: 300px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attribute-input {
  max-width: 200px;
  margin-right: 8px;
}

.attribute-textarea {
  min-width: 400px;
  max-width: 600px;
  margin-right: 8px;
  position: relative;
  z-index: 1000;
  margin-bottom: 8px;
}

.attribute-textarea /deep/ .el-textarea__inner {
  position: relative;
  z-index: 1000;
}

.attribute-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
  flex-shrink: 0;
}

.categorised-status-container .attribute-textarea ~ .attribute-actions {
  align-self: flex-start;
  margin-top: 4px;
}

.save-icon {
  cursor: pointer;
  color: #67c23a;
  font-size: 18px;
  transition: color 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.save-icon:hover {
  color: #529b2e;
}

.cancel-icon {
  cursor: pointer;
  color: #f56c6c;
  font-size: 18px;
  transition: color 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.cancel-icon:hover {
  color: #dd6161;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/categorised-attributes/FeaturedAttributes.vue